import { render } from "./MultipleRoutes.vue?vue&type=template&id=0c1d1b4a&scoped=true"
import script from "./MultipleRoutes.vue?vue&type=script&lang=js"
export * from "./MultipleRoutes.vue?vue&type=script&lang=js"

import "./MultipleRoutes.vue?vue&type=style&index=0&id=0c1d1b4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1d1b4a"]])

export default __exports__